<script>
  import { status } from "../status.js";
  import { tl } from "../multilang.js";
  import { postToHubSpot } from "./hubSpotHelper.js"
  import { fancyMessage } from "../notification.js"
  import page from "page";

  let burger = false;

  function doLogout() {
    page("/");
    $status.subscription = {};
    $status.loggedIn = false;
  }

  function doNavigation(url) {
    burger = false;
    window.scrollTo(0,0);
    page(url);
  }

    async function postHubsPotForm() {
        formLoader = true;

        const siteURL = "zaas.zoftoken.com";

        let fields = [
                {
                  "name": "email",
                  "value": emailSupport
                },
                {
                  "name": "message",
                  "value": messageSupport
                }
              ]

        postToHubSpot(fields, siteURL + $status.path, document.title) 
            .then(async (postResults) => {
                formLoader = false;    
                formResult = "<p class='has-text-success'>" + tl("Succesful submission") + "</p>" + postResults.inlineMessage;
            })
            .catch(async (error) => {
                formLoader = false;   
                formError = true;
                formResult = "<p class='has-text-danger'>" + error.message + "</p><p>" + error.errors[0].message + "</p>";
            });
    }

    function retryForm () {
      formResult = '';
      formError = false;
    }

  let distractionsFreePaths = ['/login','/registration'];
  let emailSupport = '';
  let messageSupport = '';
  let formLoader = false;
  let formResult = '';
  let formError = false;

</script>

<nav
  class="navbar is-primary has-background-black-bis is-fixed-top "
  role="navigation"
  aria-label="main navigation">

  <div class="navbar-brand">
    <a class="navbar-item" on:click={() => doNavigation('/')} >
      <img
        src="assets/zoftoken-logo-horizontal.svg"
        width="150px" />
      <span class="has-text-grey-light has-text-weight-light is-family-branded">
        / ZaaS
      </span>

    </a>

    <a
      role="button"
      class="navbar-burger burger"
      class:is-active={burger}
      on:click={() => {
        burger = !burger;
      }}>
      <span />
      <span />
      <span />
    </a>
  </div>

{#if (distractionsFreePaths.indexOf($status.path) == -1)}

  <div class="navbar-menu" class:is-active={burger}>

    <div class="navbar-start">
      {#if $status.loggedIn}
        <a class="navbar-item" on:click={() => doNavigation('/services')} class:is-active="{$status.path === '/services'}">
          {tl("My services")}
        </a>

        <a class="navbar-item" on:click={() => doNavigation('/users')}  class:is-active="{$status.path === '/users'}">{tl("My users")}</a>
      {/if}

    </div>

    <div class="navbar-end">

    {#if !$status.loggedIn}
      <div class="navbar-item has-dropdown is-hoverable is-hidden-mobile is-hidden-tablet-only">
        <a class="navbar-link navbar-secondary zt-navbar-language">
          {#if $status.language == -1}
            {tl("English")}
          {:else if $status.language == 0}
            {tl("Spanish")}
          {/if}
        </a>
        <div class="navbar-dropdown is-right zt-navbar-dropdown zt-language">
          <div class="content">
            <h4 class="navbar-secondary">{tl("Select language")}</h4>
            <p><a href="" class:disabled={$status.language == -1} on:click={() => {$status.language = -1; location.reload()}}>{tl("English")}</a></p> 
            <p><a href="" class:disabled={$status.language == 0} on:click={() => {$status.language = 0; location.reload()}}>{tl("Spanish")}</a></p>
          </div>
        </div>
      </div>
    {/if}
      <a class="navbar-item navbar-secondary" on:click={() => doNavigation('/documentation')}  class:is-active="{$status.path.startsWith('/documentation')}">{tl("Documentation")}</a>

      <div class="navbar-item has-dropdown is-hoverable is-hidden-mobile is-hidden-tablet-only">
        <a class="navbar-link navbar-secondary">
          <span class="icon">
            <ion-icon name="chatbubble-outline"></ion-icon>
          </span>
        {tl("Support")}
         </a>

        <div class="navbar-dropdown is-right zt-navbar-dropdown zt-support">
          <div class="content">
            <h4 class="navbar-secondary">{tl("Support")}</h4>
            {#if formResult}
              {@html formResult}
              {#if formError}
                <button class="button is-primary" on:click={() => retryForm()} >{tl("Retry")}</button>
              {/if}
            {:else}
            <p>
              {tl("Issues with ZaaS? Just complete this form and we will get back to you as soon as possible.")}
            </p>
            <div class="zt-field-wrapper">
              <label class="zt-label">E-mail</label>
              <input type="email" class="input gap gap-bottom" bind:value={emailSupport} placeholder="john-doe@domain.com">
            </div>

            <div class="zt-field-wrapper">
              <label class="zt-label">Message</label>
              <textarea class="textarea" placeholder={tl("e.g. Can I enable the duress function after a service created?")} bind:value={messageSupport}/>
            </div>
            <div class="buttons">
              <button class="button is-primary" on:click={() => postHubsPotForm()} class:is-loading={formLoader} >{tl("Submit")}</button>
            </div>
            {/if}
          </div>

          <hr class="navbar-divider" />
          <a class="" on:click={() => doNavigation('/documentation')}>{tl("Technical documentation")}</a>
        </div>
      </div>

      {#if $status.loggedIn}
        <div class="navbar-item has-dropdown is-hoverable is-hidden-mobile is-hidden-tablet-only">
          <a class="navbar-link">{$status.subscription.email}</a>

          <div class="navbar-dropdown is-right zt-navbar-dropdown zt-user">
          <div class="zt-field-wrapper">
              <label class="zt-label">{tl("Subscription")}</label>
              <p>{$status.subscription.id}</p>
          </div>

            <hr class="navbar-divider" />
            <a
              class="has-text-primary	"
              on:click={() => doNavigation('/credentials')}>
              {tl("My credentials")}
            </a>
            <hr class="navbar-divider" />
            <a
              class="has-text-primary	"
              on:click={() => doNavigation('/delete')}>
              {tl("Delete subscription")}
            </a>
            <hr class="navbar-divider" />
            <a class="has-text-primary	" on:click={doLogout}>{tl("Log out")}</a>

          </div>
        </div>
      {:else}

          <a class="navbar-item zt-navbar-login" on:click={() => doNavigation('/login')}>
            {tl("Log in")}
          </a>


        <div class="navbar-item">
          <a
            class="button is-primary"
            on:click={() => doNavigation('/registration')}>
            {tl("Get ZaaS for free!")}
          </a>
        </div>
      {/if}
    </div>

  </div>
{/if}
</nav>
